import moment from "moment";
import { FilterActionObject } from "@/types/interface";

function filterFunction(arr: Array<string>, filters: FilterActionObject) {
  const arrFiltered = arr.filter((x) => {
    return Object.keys(filters).every(function (key) {
      //No filter added to key then return true
      if (filters[key].value === undefined || filters[key].value === null) {
        return true;
      }
      //Find type of filter
      switch (filters[key].type) {
        case "date": {
          return moment(x[key]).isSame(filters[key].value, "day");
        }

        case "int": {
          return x[key] === filters[key].value;
        }

        default: {
          const str = isNaN(x[key]) ? x[key] : x[key].toString();
          return str.toUpperCase().includes(filters[key].value.toUpperCase());
        }
      }
    });
  });

  return arrFiltered;
}

//Filter table
function filterTypeTable(value, filterValues, type, filterClause) {
  let res = false;

  switch (type) {
    case "string": {
      if (value) {
        //Convert int to string
        const str = isNaN(value) ? value : value.toString();
        //Convert filterValues to string
        const filterValue = isNaN(filterValues)
          ? filterValues
          : filterValues.toString();

        switch (filterClause) {
          case 1:
            //starter med
            res = str.toLowerCase().startsWith(filterValue.toLowerCase());
            break;
          case 2:
            //Slutter med
            res = str.toLowerCase().endsWith(filterValue.toLowerCase());
            break;
          case 3:
            //Lik som
            res = str.toLowerCase() === filterValue.toLowerCase();
            break;
          default:
            if (Array.isArray(filterValue)) {
              filterValue.some((x) => (isNaN(x) ? x : x.toString() === str));
              break;
            } else {
              //Inneholder
              res = str.toLowerCase().includes(filterValue.toLowerCase());
              break;
            }
        }
        return res;
      }
      return false;
    }

    //Filter for date
    case "date": {
      if (filterValues) {
        switch (filterClause) {
          case 1:
            //Før
            res = moment(value).isBefore(filterValues, "day");
            break;
          case 2:
            //Etter
            res = moment(value).isAfter(filterValues, "day");
            break;
          case 3:
            if (filterValues.length > 1) {
              //mellom
              res = moment(value).isBetween(filterValues[0], filterValues[1]);
            } else {
              res = true;
            }
            break;
          default:
            //Lik som
            res = moment(value).isSame(filterValues, "day");
            break;
        }
        return res;
      }
      return true;
    }
    //Filter for select
    case "select": {
      const filterArray = JSON.parse(filterValues);

      if (filterArray.length > 0) {
        return filterArray.some((x) => x === value);
      }
      return true;
    }
    case "boolean": {
      if (JSON.parse(filterValues)) {
        return value === JSON.parse(filterValues);
      } else {
        //if filterValues is not true. Then return false and undefined
        return value !== true;
      }
    }
    case "number": {
      return value === filterValues;
    }

    default:
      return true;
  }
}

export default { filterFunction, filterTypeTable };
